import request from '@/utils/request'

// 维度配置 API
export function getDimensionList(params) {
  return request({
    url: '/api/admin/dimension-config/list',
    method: 'post',
    data: params
  })
}

export function getDimension(id) {
  return request({
    url: '/api/admin/dimension-config/get',
    method: 'post',
    params: { id }
  })
}

export function saveDimension(data) {
  return request({
    url: '/api/admin/dimension-config/save',
    method: 'post',
    data
  })
}

export function deleteDimension(id) {
  return request({
    url: '/api/admin/dimension-config/delete',
    method: 'post',
    params: { id }
  })
}

export function getDimensionTree() {
  return request({
    url: '/api/admin/dimension-config/tree',
    method: 'post'
  })
}

// 知识库 API
export function getKnowledgeList(params) {
  return request({
    url: '/api/admin/knowledge-base/list',
    method: 'post',
    data: params
  })
}

export function getKnowledge(id) {
  return request({
    url: '/api/admin/knowledge-base/get',
    method: 'post',
    params: { id }
  })
}

export function saveKnowledge(data) {
  return request({
    url: '/api/admin/knowledge-base/save',
    method: 'post',
    data
  })
}

export function deleteKnowledge(id) {
  return request({
    url: '/api/admin/knowledge-base/delete',
    method: 'post',
    params: { id }
  })
}

export function bindKnowledgeDimensions(data) {
  return request({
    url: '/api/admin/knowledge-base/bind-dimensions',
    method: 'post',
    data
  })
}

export function bindKnowledgeTags(data) {
  return request({
    url: '/api/admin/knowledge-base/bind-tags',
    method: 'post',
    data
  })
}

export function uploadKnowledgeFile(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/api/admin/knowledge-base/upload-file',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export function fetchUrlContent(url) {
  return request({
    url: '/api/admin/knowledge-base/fetch-url',
    method: 'post',
    data: { url }
  })
}

// 标签 API
export function getTagList() {
  return request({
    url: '/api/admin/knowledge-tag/list',
    method: 'post'
  })
}

export function saveTag(data) {
  return request({
    url: '/api/admin/knowledge-tag/save',
    method: 'post',
    data
  })
}

export function deleteTag(id) {
  return request({
    url: '/api/admin/knowledge-tag/delete',
    method: 'post',
    params: { id }
  })
}
